import { SimpleGrid } from "@chakra-ui/layout";
import { useParams } from "react-router";

import { useCurrentTenant } from "core/features/auth/tenant.store";

import CardBoletos from "./components/CardBoletos";
import CardAcordos from "./components/CardAcordos";
import CardReservas from "./components/CardReservas";
import CardMensagens from "./components/CardMensagens";
import CardHistoricoPessoas from "./components/CardHistoricoPessoas/index";

function Dashboard({ unidadeId }: { unidadeId: string }) {
  const route = useParams<{ tenant: string }>();

  const { tenant } = useCurrentTenant();

  return (
    <>
      <SimpleGrid columns={2} gap="16px">
        <CardBoletos unidadeId={unidadeId} />
        <CardAcordos unidadeId={unidadeId} />
        <CardReservas
          tenantId={route.tenant ?? tenant.id}
          unidadeId={unidadeId}
        />
        <CardMensagens unidadeId={unidadeId} />
      </SimpleGrid>
      <SimpleGrid columns={1} mt="16px">
        <CardHistoricoPessoas
          unidadeId={unidadeId}
          tenantId={route.tenant ?? tenant.id}
        />
      </SimpleGrid>
    </>
  );
}

export default Dashboard;
